import React from 'react';
import cn from 'classnames';
import { bool, number, string, node, func, shape, oneOfType } from 'prop-types';

const getButtonText = (title) => `${title}`;

const SocialButton = ({ network, onClick, isLoading, children, className, requestType }) => {
  const { provider, title } = network;
  const showLoadingMessage = isLoading && provider === requestType;
  const isID = provider === 'vk' ? 'ID' : '';

  return (
    <span className={cn('auth-button-container', className)}>
      <button
        type="button"
        className={`btn btn-auth btn-${network.provider}`}
        onClick={onClick}
        disabled={isLoading}
      >
        <span className="btn-icon" />
        Войти через {showLoadingMessage ? 'loading...' : children || getButtonText(title)} {isID}
      </button>
    </span>
  );
};

SocialButton.propTypes = {
  network: shape({
    appId: oneOfType([number, string]).isRequired,
    provider: string.isRequired,
    title: string.isRequired,
  }).isRequired,
  onClick: func.isRequired,
  isLoading: bool,
  children: node,
  className: string,
  requestType: string,
};

SocialButton.defaultProps = {
  isLoading: false,
  network: {},
};

export default SocialButton;
